import * as R from "ramda";
import { CommonRectangle } from "@/stencils/utils/commonShape";
import { SVG } from "@svgdotjs/svg.js";

const stencilName = "输入";
const icon = require("./icon.svg");

const shape = CommonRectangle.define(
  "stencil.input",
  {},
  {
    stencilName,
    stencilType: "input",
    labelGroupImageAttrs: {
      width: 24,
      height: 24,
      "xlink:href": icon,
    },
    dataWatch: {
      inputType: function (prevData, newData) {
        const cell = this;
        const { inputType: newInputType, constantValue: newConstantValue } =
          newData;
        let text = "";
        if (newInputType === "constant") {
          text = "常量";
          if (!R.isNil(newConstantValue)) text = `${text}: ${newConstantValue}`;
          cell.attr("labelGroupText/text", text);
          cell.resetCellSize();
        } else if (newInputType === "device") {
          text = "设备输入";
          cell.attr("labelGroupText/text", text);
          cell.resetCellSize();
        } else if (newInputType === "enumeration") {
          text = "枚举";
          cell.attr("labelGroupText/text", text);
          cell.resetCellSize();
        }
      },
      constantValue: function (prevData, newData) {
        const cell = this;
        const { inputType: newInputType, constantValue: newConstantValue } =
          newData;
        let text = "";
        if (newInputType === "constant") {
          text = "常量";
          if (!R.isNil(newConstantValue)) text = `${text}: ${newConstantValue}`;
          cell.attr("labelGroupText/text", text);
          cell.resetCellSize();
        }
      },
    },
  }
);

const svg = (() => {
  const draw = SVG().size(32, 32);
  draw
    .rect(32, 32)
    .attr({ fill: "#010016", stroke: "rgba(41, 54, 70, 1)", strokeWidth: 1 });
  draw.image(icon).size(24, 24).move(3, 3);
  return draw.svg();
})();

const initData = {
  inputType: "",
  constantValue: undefined,
  modelType: "",
  thingsModalId: undefined,
  modelPropertyId: undefined,
  modelPropertyDeviceId: undefined,
  enumerationId: undefined,
};

const createCell = (position) => {
  const cell = shape
    .create({
      data: R.clone(initData),
      size: { width: 32, height: 32 },
      ports: { in: 0, out: 1, maxOutLinkNumber: -1 },
      labelText: "input",
    })
    .position(position.x, position.y);

  return cell;
};

const reloadCell = (cellJson) => {
  const cell = shape.reloadCell({
    cellJson,
    initData: R.clone(initData),
    ports: { maxOutLinkNumber: -1 },
  });

  cell.watcher({}, cellJson.attrs.data);

  return cell;
};

export default {
  createCell,
  reloadCell,
  icon,
  svg,
  group: "InputOutput",
  stencilName,
  sortNo: 13,
};
